// Mounts the RangeControl into a binding's value cell (`.mz-lblv_v`) — the
// orchestrator seam (DOM touch allowed). The custom Pane leaves numeric/interval
// value cells empty, so there's nothing native to hide; we just render ours.
//
// RangeControl is the only slider now (no native slider remains). `useCustomSlider`
// stays exported as `true` so the `useCustomSlider ? mount : fallback` call
// sites (slices, selections) keep their shape — the fallback is now dead.

import { createRangeControl } from '../controls/rangeControl';
import type { RangeControlHandle, RangeControlOpts } from '../controls/rangeControl';
import type { TBindingLike } from './types';

export const useCustomSlider = true;

/** Mount a RangeControl into the binding's value cell. Returns null only if the
 *  expected cell isn't present (caller keeps any fallback wiring). */
export function mountRangeControl(binding: TBindingLike, opts: RangeControlOpts): RangeControlHandle | null {
    const cell = binding.element?.querySelector<HTMLElement>('.mz-lblv_v');
    if (!cell) return null;
    const ctrl = createRangeControl(opts);
    cell.appendChild(ctrl.el);
    return ctrl;
}
